import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';

const AboutPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Acerca de Facto
      </Typography>
      
      <Paper elevation={2} sx={{ p: 4, my: 4 }}>
        <Typography variant="h5" gutterBottom>
          Nuestra Misión
        </Typography>
        <Typography paragraph>
          Facto tiene la misión de revolucionar la industria del factoraje creando un mercado 
          transparente, eficiente y seguro que conecta empresas que necesitan flujo de efectivo inmediato 
          con inversionistas que buscan oportunidades de inversión atractivas a corto plazo.
        </Typography>
        <Typography paragraph>
          Creemos que cada empresa, sin importar su tamaño, debe tener acceso al capital que necesita 
          para crecer y prosperar. Al aprovechar la tecnología, estamos haciendo el factoraje 
          más accesible, asequible y directo que nunca antes.
        </Typography>
      </Paper>
      
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: 4, height: '100%' }}>
            <Typography variant="h5" gutterBottom>
              Nuestra Historia
            </Typography>
            <Typography paragraph>
              Fundada en 2022, Facto nació del reconocimiento de que las soluciones tradicionales de 
              factoraje a menudo eran inaccesibles para pequeñas y medianas empresas debido a altas 
              tarifas, procesos complejos y falta de transparencia.
            </Typography>
            <Typography paragraph>
              Nuestro equipo de expertos financieros e innovadores tecnológicos se unió para crear una 
              plataforma que simplifica el proceso de factoraje, reduce costos a través de la competencia 
              y proporciona una experiencia fluida tanto para empresas como para inversionistas.
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: 4, height: '100%' }}>
            <Typography variant="h5" gutterBottom>
              Nuestros Valores
            </Typography>
            <Typography paragraph>
              <strong>Transparencia:</strong> Creemos en la transparencia completa en todas nuestras 
              operaciones, desde nuestra estructura de tarifas hasta nuestros procesos de verificación.
            </Typography>
            <Typography paragraph>
              <strong>Seguridad:</strong> Implementamos los más altos estándares de seguridad para 
              proteger los datos de nuestros usuarios y las transacciones financieras.
            </Typography>
            <Typography paragraph>
              <strong>Innovación:</strong> Innovamos continuamente para mejorar nuestra plataforma y 
              brindar la mejor experiencia posible a nuestros usuarios.
            </Typography>
            <Typography paragraph>
              <strong>Integridad:</strong> Conducimos nuestro negocio con el más alto nivel de 
              integridad y estándares éticos.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      
      <Box sx={{ mt: 6 }}>
        <Typography variant="h5" gutterBottom align="center">
          Únete a nosotros para transformar el futuro del financiamiento empresarial
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutPage;
